var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMultipleChoiceIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.859,
    height: 17.885,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 173",
    d: "M4.65 7.872a.887.887 0 000 1.253l2.889 2.886a.72.72 0 001.018 0l7.808-7.808a.887.887 0 000-1.253.887.887 0 00-1.253 0L8.558 9.505a.72.72 0 01-1.019 0L5.903 7.87a.887.887 0 00-1.253.002zm11.418 1.756a7.154 7.154 0 01-7.224 6.468 7.25 7.25 0 01-7.051-7.049 7.153 7.153 0 017.15-7.258 6.936 6.936 0 011.487.149.9.9 0 00.83-.231.889.889 0 00-.431-1.5 10.847 10.847 0 00-1.886-.208 8.942 8.942 0 00-8.939 9.2 9.221 9.221 0 009.205 8.684 8.945 8.945 0 008.649-8.216c.019-.239-.072-.724-1.036-.723h-.035a.734.734 0 00-.719.684z",
    fill: "#5200f1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultipleChoiceIcon);
export default __webpack_public_path__ + "static/media/multiple-choice-icon.0d61ed672ffa40c438e93deff16f321c.svg";
export { ForwardRef as ReactComponent };